import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = axios.create({ baseURL: `${BACKEND_URL}/api`, timeout: 20000 });

// Attach admin token when available
API.interceptors.request.use((cfg) => {
  const token = localStorage.getItem('aegis_admin_token');
  if (token && cfg.url?.startsWith('/admin')) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${token}`;
  }
  return cfg;
});

export const publicApi = {
  meta: (lang) => API.get('/meta', { params: { lang } }).then((r) => r.data),
  translations: (lang) => API.get(`/translations/${lang}`).then((r) => r.data),
  categories: (lang) => API.get('/categories', { params: { lang } }).then((r) => r.data),
  products: (lang, category, featured) => API.get('/products', { params: { lang, category, featured } }).then((r) => r.data),
  product: (slug, lang) => API.get(`/products/${slug}`, { params: { lang } }).then((r) => r.data),
  servers: (type, lang) => API.get('/servers', { params: { server_type: type, lang } }).then((r) => r.data),
  faqs: (lang) => API.get('/faqs', { params: { lang } }).then((r) => r.data),
  freeProducts: (lang) => API.get('/free-products', { params: { lang } }).then((r) => r.data),
  freeProduct: (slug, lang) => API.get(`/free-products/${slug}`, { params: { lang } }).then((r) => r.data),
  projects: (lang) => API.get('/projects', { params: { lang } }).then((r) => r.data),
  updates: (lang, projectId) => API.get('/updates', { params: { lang, project_id: projectId } }).then((r) => r.data),
  update: (slug, lang) => API.get(`/updates/${slug}`, { params: { lang } }).then((r) => r.data),
  page: (slug, lang) => API.get(`/pages/${slug}`, { params: { lang } }).then((r) => r.data),
  blog: (lang) => API.get('/blog', { params: { lang } }).then((r) => r.data),
  blogPost: (slug, lang) => API.get(`/blog/${slug}`, { params: { lang } }).then((r) => r.data),
  gallery: (lang) => API.get('/gallery', { params: { lang } }).then((r) => r.data),
  mobileApps: (lang) => API.get('/mobile-apps', { params: { lang } }).then((r) => r.data),
  references: (lang) => API.get('/references', { params: { lang } }).then((r) => r.data),
  testimonials: (lang) => API.get('/testimonials', { params: { lang } }).then((r) => r.data),
  contact: (payload) => API.post('/contact', payload).then((r) => r.data),
  newsletter: (email) => API.post('/newsletter/subscribe', { email }).then((r) => r.data),
};

export const adminApi = {
  login: (email, password) => API.post('/admin/login', { email, password }).then((r) => r.data),
  me: () => API.get('/admin/me').then((r) => r.data),
  stats: () => API.get('/admin/stats').then((r) => r.data),
  analytics: () => API.get('/admin/analytics').then((r) => r.data),
  list: (coll) => API.get(`/admin/${coll}`).then((r) => r.data),
  get: (coll, id) => API.get(`/admin/${coll}/${id}`).then((r) => r.data),
  create: (coll, payload) => API.post(`/admin/${coll}`, payload).then((r) => r.data),
  update: (coll, id, payload) => API.put(`/admin/${coll}/${id}`, payload).then((r) => r.data),
  remove: (coll, id) => API.delete(`/admin/${coll}/${id}`).then((r) => r.data),
  saveSettings: (payload) => API.post('/admin/settings/bulk', payload).then((r) => r.data),
  upload: (file) => {
    const fd = new FormData(); fd.append('file', file);
    return API.post('/admin/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
  uploadProtected: (file) => {
    const fd = new FormData(); fd.append('file', file);
    return API.post('/admin/upload-protected', fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
  },
  uploads: () => API.get('/admin/uploads').then((r) => r.data),
  deleteUpload: (name) => API.delete(`/admin/uploads/${name}`).then((r) => r.data),
  sendMail: (payload) => API.post('/admin/mail/send', payload).then((r) => r.data),
  post: (url, payload) => API.post('/admin' + (url.startsWith('/') ? url : '/' + url), payload).then((r) => r.data),
  sendUpdateNotification: (id) => API.post(`/admin/send_update_notification/${id}`).then((r) => r.data),
  sendBlogNotification: (id) => API.post(`/admin/send_blog_notification/${id}`).then((r) => r.data),
};
